import Client from '../interfaces/Client'
import Vehicle from '../interfaces/Vehicle'

import SalenoteEdit from './SalenoteEdit'

const SalenoteCrea: React.FC<{ vehicle: Vehicle; client: Client }> = ({ vehicle, client }) => {
  return <SalenoteEdit vehicle={vehicle} client={client} />
}

export default SalenoteCrea
